import React, { useEffect, useRef, memo } from 'react';

/**
 * Widget TradingView Advanced Chart (lecture seule).
 * Config d'origine (bougies, barre du haut pour choisir le type d'affichage,
 * timeframes, volume, plages de dates) — on masque uniquement la colonne
 * d'outils de dessin à gauche (hide_side_toolbar).
 * Le symbole est verrouillé (allow_symbol_change: false).
 */

// Mapping symbole → paire TradingView (Binance USDT)
const TV_SYMBOLS = {
  BTC: 'BINANCE:BTCUSDT',
  ETH: 'BINANCE:ETHUSDT',
  BNB: 'BINANCE:BNBUSDT',
  XRP: 'BINANCE:XRPUSDT',
  ADA: 'BINANCE:ADAUSDT',
  SOL: 'BINANCE:SOLUSDT',
  DOGE: 'BINANCE:DOGEUSDT',
  DOT: 'BINANCE:DOTUSDT',
  POL: 'BINANCE:POLUSDT',
  LTC: 'BINANCE:LTCUSDT',
  AVAX: 'BINANCE:AVAXUSDT',
  LINK: 'BINANCE:LINKUSDT',
  TRX: 'BINANCE:TRXUSDT',
  SHIB: 'BINANCE:SHIBUSDT',
  UNI: 'BINANCE:UNIUSDT',
  ATOM: 'BINANCE:ATOMUSDT',
  XLM: 'BINANCE:XLMUSDT',
  NEAR: 'BINANCE:NEARUSDT',
  BCH: 'BINANCE:BCHUSDT',
  TON: 'BINANCE:TONUSDT'
};

const TradingViewChart = ({ symbol, locale = 'fr', showTools = false }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    // Nettoyer le widget précédent
    containerRef.current.innerHTML = '';

    const widgetDiv = document.createElement('div');
    widgetDiv.className = 'tradingview-widget-container__widget';
    widgetDiv.style.height = '100%';
    widgetDiv.style.width = '100%';
    containerRef.current.appendChild(widgetDiv);

    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js';
    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML = JSON.stringify({
      autosize: true,
      symbol: TV_SYMBOLS[symbol] || `BINANCE:${symbol}USDT`,
      interval: '1',
      timezone: 'Europe/Paris',
      theme: 'dark',
      style: '1',
      locale: locale === 'en' ? 'en' : 'fr',
      withdateranges: true,
      // Colonne d'outils de dessin à gauche: masquée par défaut, affichée si
      // l'utilisateur active le bouton "Outils" (prop showTools).
      hide_side_toolbar: !showTools,
      allow_symbol_change: false,
      save_image: true,
      calendar: false,
      hide_volume: false,
      support_host: 'https://www.tradingview.com'
    });
    containerRef.current.appendChild(script);

    return () => {
      if (containerRef.current) containerRef.current.innerHTML = '';
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [symbol, locale, showTools]);

  return (
    <div
      className="tradingview-widget-container"
      ref={containerRef}
      style={{ height: '100%', width: '100%' }}
    />
  );
};

export default memo(TradingViewChart);
